import { userTasks as constants } from "store/constants";
import {
	fetchableInitialState,
	reduceIsFetching,
	reduceSetError,
} from "store/factories/fetchable";


const initialState = {
	...fetchableInitialState,
	content: {
		userTasks: [],
	},
};

export function userTaskList(state = initialState, action) {
	switch (action.type) {
		case constants.USER_TASKS_IS_FETCHING:
			return reduceIsFetching(state, action);
		case constants.USER_TASKS_SET_ERROR:
			return reduceSetError(state, action);
		case constants.USER_TASKS_SET_DATA:
			return {
				...state,
				content: {
					...state.content,
          ...action.payload,
				},
			};
		case constants.RESET:
			return initialState;
		default:
			return state;
	}
}
